var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stethoscope"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33328 1.3328V2.66619M3.33296 1.3328V2.66619M3.33296 1.99949H2.66624C2.31259 1.99949 1.97342 2.13998 1.72336 2.39004C1.47329 2.64009 1.3328 2.97925 1.3328 3.33288V5.99966C1.3328 7.06057 1.75426 8.07803 2.50447 8.82821C3.25467 9.57839 4.27217 9.99983 5.33312 9.99983M5.33312 9.99983C6.39407 9.99983 7.41157 9.57839 8.16177 8.82821C8.91198 8.07803 9.33344 7.06057 9.33344 5.99966V3.33288C9.33344 2.97925 9.19295 2.64009 8.94288 2.39004C8.69282 2.13998 8.35365 1.99949 8 1.99949H7.33328M5.33312 9.99983C5.33312 11.0607 5.75458 12.0782 6.50479 12.8284C7.25499 13.5786 8.27249 14 9.33344 14C10.3944 14 11.4119 13.5786 12.1621 12.8284C12.9123 12.0782 13.3338 11.0607 13.3338 9.99983V7.99975M13.3338 7.99975C14.0702 7.99975 14.6672 7.40277 14.6672 6.66636C14.6672 5.92995 14.0702 5.33297 13.3338 5.33297C12.5973 5.33297 12.0003 5.92995 12.0003 6.66636C12.0003 7.40277 12.5973 7.99975 13.3338 7.99975Z",
    stroke: "#1B8C5A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.a80413be2c27d14433badbf96b1dbc70.svg";
export { ForwardRef as ReactComponent };